import { Component, Input, Output, EventEmitter } from '@angular/core';
import { modalAnimations, ModalAnimationState } from './modal.animations';

@Component({
  selector: 'modal',
  templateUrl: 'modal.component.html',
  styleUrls: ['modal.component.scss'],
  animations: modalAnimations
})
export class ModalComponent {
  @Input() id: string;
  @Output() modalClosed = new EventEmitter();

  get currentAnimationState() { return this._currentAnimationState; }
  private _currentAnimationState: string = ModalAnimationState.inactive;

  open(): void {
    this._currentAnimationState = ModalAnimationState.active;
  }

  close(): void {
    this._currentAnimationState = ModalAnimationState.inactive;
    this.modalClosed.emit();
  }
}
